/* eslint-disable no-new */

import 'core-js/modules/es.map';

/**
 * @desc Required for IE or any other browser that does not support native promises.
 * @see {@link https://github.com/taylorhakes/promise-polyfill}
 */
import 'promise-polyfill/src/polyfill';
/**
 * @desc window.fetch is not part of ECMAScript, but a web standard.
 * While babel-polyfill does include some web standards, fetch is currently not one of them.
 * @see https://github.com/github/fetch
 */
import 'whatwg-fetch';
import smoothscroll from 'smoothscroll-polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import lazySizes from 'lazysizes';
import { ElementQueries } from 'css-element-queries';
import generalModules from './modules/general';
import freeformModules from './modules/freeform';
import formsModules from './modules/forms';
import headerModules from './modules/header';
import newsModules from './modules/news';
import homeModules from './modules/home';
import CityNow from './modules/citynow';
import PartnersSection from './modules/partners-section';
import GoogleCalendar from './modules/google-calendar';
import gtmModules from './modules/gtm';
import helpModules from './modules/help';
import Confetti from './modules/freeform/confetti';
import brazeModules from './modules/braze';
import CWCBrackets from './modules/cwc-brackets';
import UclBrackets from './modules/ucl-brackets';

window.mcInitGoogleCalendar = () => new GoogleCalendar();

$(() => {
  /**
   * @desc Polyfill for the native scroll-behavior.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior}
   * @see {@link https://github.com/iamdustan/smoothscroll}
   */
  smoothscroll.polyfill();

  /**
   * @desc For external SVG spritemaps.
   * @see {@link https://github.com/jonathantneal/svg4everybody}
   */
  svg4everybody({});

  /**
   * @desc Lazy loader for images.
   * @see {@link https://github.com/aFarkas/lazysizes}
   */
  lazySizes.init();

  // eslint-disable-next-line no-unused-vars
  const modules = [
    ...generalModules,
    ...freeformModules,
    ...formsModules,
    ...headerModules,
    ...homeModules,
    ...newsModules,
    ...helpModules,
    ...brazeModules,
    new PartnersSection({
      partnersListSelector: '.js-partners-list',
      partnerLogoSelector: '.js-partner-logo',
      defaultCountryCode: 'GB',
      persistKey: 'mc-user-location',
      partnersSectionSelector: '.js-partners-section',
    }),
    new CityNow(),
    new CWCBrackets(),
    new UclBrackets(),
    ...gtmModules,
  ];
  /* eslint-disable no-console, no-prototype-builtins */
  if (process.env.IS_DEVELOPMENT) {
    console.group('Main modules summary');
    console.log(
      'Active modules:',
      modules
        .filter((widget) => widget && widget.isInitialized)
        .map((widget) => widget.constructor.name),
    );
    console.log(
      'Inactive modules:',
      modules
        .filter(
          (widget) => widget && widget.hasOwnProperty('isInitialized') && !widget.isInitialized,
        )
        .map((widget) => widget.constructor.name),
    );
    console.groupEnd('Main modules summary');
  }
  /* eslint-enable no-console, no-prototype-builtins */
});
$(window).on('load', () => {
  /**
   * @desc Adds support for element based media-queries.
   * @see {@link https://github.com/marcj/css-element-queries}
   */
  ElementQueries.init();
});

window.Confetti = new Confetti();
